import * as moment from "moment-timezone";
import * as firebase from "firebase";

export abstract class TimeframeFilter {
  private _begin: Date;
  private _end: Date;
  public label: string;
  constructor(label: string, begin: Date, end: Date) {
    this._begin = begin;
    this._end = end;
    this.label = label;
  }

  public get begin(): firebase.firestore.Timestamp {
    return firebase.firestore.Timestamp.fromDate(this._begin);
  }
  public get end(): firebase.firestore.Timestamp {
    return firebase.firestore.Timestamp.fromDate(this._end);
  }
}

export class TodayFilter extends TimeframeFilter {
  constructor() {
    super(
      "Today",
      moment()
        .startOf("day")
        .add(4, "hours")
        .subtract(
          moment()
            .toDate()
            .getHours() < 4
            ? 1
            : 0,
          "days"
        )
        .toDate(),
      moment()
        .endOf("day")
        .add(4, "hours")
        .subtract(
          moment()
            .toDate()
            .getHours() < 4
            ? 1
            : 0,
          "days"
        )
        .toDate()
    );
  }
}

export class YesterdayFilter extends TimeframeFilter {
  constructor() {
    super(
      "Yesterday",
      moment()
        .startOf("day")
        .subtract(1, "day")
        .add(4, "hours")
        .subtract(
          moment()
            .toDate()
            .getHours() < 4
            ? 1
            : 0,
          "days"
        )
        .toDate(),
      moment()
        .startOf("day")
        .add(4, "hours")
        .subtract(
          moment()
            .toDate()
            .getHours() < 4
            ? 1
            : 0,
          "days"
        )
        .toDate()
    );
  }
}

export class WeekToDateFilter extends TimeframeFilter {
  constructor() {
    super(
      "Week to Date",
      moment()
        .startOf("week")
        .add(4, "hours")
        .toDate(),
      moment()
        .endOf("week")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class Last7DaysFilter extends TimeframeFilter {
  constructor() {
    super(
      "Last 7 Days",
      moment()
        .startOf("day")
        .subtract(7, "days")
        .add(4, "hours")
        .toDate(),
      moment()
        .endOf("week")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class LastWeekFilter extends TimeframeFilter {
  constructor() {
    super(
      "Last Week",
      moment()
        .startOf("week")
        .subtract(7, "days")
        .add(4, "hours")
        .toDate(),
      moment()
        .startOf("week")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class MonthToDateFilter extends TimeframeFilter {
  constructor() {
    super(
      "Month to Date",
      moment()
        .startOf("month")
        .add(4, "hours")
        .toDate(),
      moment()
        .endOf("month")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class Last30DaysFilter extends TimeframeFilter {
  constructor() {
    super(
      "Last 30 Days",
      moment()
        .startOf("day")
        .subtract(30, "days")
        .add(4, "hours")
        .toDate(),
      moment()
        .endOf("week")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class LastMonthFilter extends TimeframeFilter {
  constructor() {
    super(
      "Last Month",
      moment()
        .startOf("month")
        .subtract("1", "month")
        .add(4, "hours")
        .toDate(),
      moment()
        .startOf("month")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class YearToDateFilter extends TimeframeFilter {
  constructor() {
    super(
      "Year to Date",
      moment()
        .startOf("year")
        .add(4, "hours")
        .toDate(),
      moment()
        .endOf("year")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class Last12MonthsFilter extends TimeframeFilter {
  constructor() {
    super(
      "Last 12 Months",
      moment()
        .startOf("day")
        .subtract(12, "months")
        .add(4, "hours")
        .toDate(),
      moment()
        .endOf("d")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class LastCalendarYear extends TimeframeFilter {
  constructor() {
    super(
      "Last Calendar Year",
      moment()
        .startOf("year")
        .subtract(1, "year")
        .add(4, "hours")
        .toDate(),
      moment()
        .startOf("year")
        .add(4, "hours")
        .toDate()
    );
  }
}

export class CustomTimeframeFilter extends TimeframeFilter {
  constructor(begin: Date, end: Date) {
    super(
      "Custom Date",
      moment(begin)
        .startOf("D")
        .add(4, "hours")
        .toDate(),
      moment(end)
        .startOf("D")
        .add(4, "hours")
        .toDate()
    );
  }
}
